/* ============================================================
   CK Delivery Engine — Paleo Levi
   Built by CK Digital.
   Custom elements: <ck-delivery>, <ck-freeship>, <ck-upsell>,
   <ck-popup-extra>. Config injected by sections/ck-delivery.liquid
   as JSON (#ck-delivery-config). Data assets: ck-cities.json,
   ck-st-<code>.json. Writes Bird-compatible cart attributes and
   hands off method+address to checkout via Storefront Cart API.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ckDeliveryLoaded) return; window.__ckDeliveryLoaded = true;

  /* ---------- icons (original CK set) ---------- */
  var I = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M3 14V7h11v7M14 10h4l3 3v1h-7" stroke-linejoin="round"/><circle cx="7" cy="16.5" r="1.8"/><circle cx="17.5" cy="16.5" r="1.8"/></svg>',
    store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 10v9h16v-9M3 10l1.5-5h15L21 10a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-4 0z" stroke-linejoin="round"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s-7-6.5-7-12a7 7 0 0 1 14 0c0 5.5-7 12-7 12z" stroke-linejoin="round"/><circle cx="12" cy="10" r="2.6"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12l5 5L20 6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 5v14M5 12h14" stroke-linecap="round"/></svg>',
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="5" width="16" height="16" rx="2.5"/><path d="M4 9h16M8 3v4M16 3v4" stroke-linecap="round"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 4l9 16H3z" stroke-linejoin="round"/><path d="M12 10v4M12 17v.5" stroke-linecap="round"/></svg>',
    flame: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3c1 3 4 4 4 8a4 4 0 0 1-8 0c0-1 .3-1.8.7-2.5C9 10 11 8 12 3z" stroke-linejoin="round"/></svg>',
    snow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3v18M4.5 7.5l15 9M19.5 7.5l-15 9" stroke-linecap="round"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l2.4 5 5.6.7-4 3.9 1 5.4L12 21l-5-2.1 1-5.4-4-3.9 5.6-.7z" stroke-linejoin="round"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.02 2C6.58 2 2.16 6.42 2.16 11.86c0 1.9.5 3.68 1.38 5.22L2 22l5.06-1.5a9.8 9.8 0 0 0 4.96 1.35h.01c5.44 0 9.86-4.42 9.86-9.86S17.46 2 12.02 2zm5.8 14.03c-.24.68-1.4 1.3-1.94 1.34-.5.05-1.13.24-3.68-.77-3.1-1.22-5.06-4.34-5.22-4.55-.15-.2-1.24-1.65-1.24-3.15s.79-2.24 1.07-2.54c.28-.3.6-.38.8-.38l.58.01c.19.01.44-.07.68.52.24.6.83 2.07.9 2.22.08.15.12.32.02.52-.1.2-.15.32-.3.5l-.44.5c-.15.15-.3.31-.13.6.17.3.77 1.27 1.66 2.06 1.14 1.02 2.1 1.34 2.4 1.49.3.15.47.12.64-.07.17-.2.73-.86.93-1.15.2-.3.4-.25.67-.15.28.1 1.76.83 2.06.98.3.15.5.22.57.35.08.13.08.74-.16 1.42z"/></svg>'
  };

  /* ---------- config ---------- */
  function readConfig() {
    var el = document.getElementById('ck-delivery-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var CFG = readConfig() || {};
  CFG.min = CFG.min || 50000; CFG.free = CFG.free || 100000; CFG.fee = CFG.fee || 3990;
  CFG.cutoff = CFG.cutoff || '08:00';
  CFG.windows = CFG.windows && CFG.windows.length ? CFG.windows : ['10:00-14:00', '14:00-18:00', '18:00-21:00'];
  CFG.wa = CFG.wa || '972505340421';
  CFG.blackout = CFG.blackout || [];
  CFG.zones = CFG.zones || [];
  CFG.pickupAddress = CFG.pickupAddress || 'גורדון 18, כפר סבא';
  CFG.assets = CFG.assets || {};
  var DAY_HE = { 0:'ראשון',1:'שני',2:'שלישי',3:'רביעי',4:'חמישי',5:'שישי',6:'שבת' };
  var DAY_EN = { 0:'Sunday',1:'Monday',2:'Tuesday',3:'Wednesday',4:'Thursday',5:'Friday',6:'Saturday' };
  var MON_EN = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  /* ---------- utils ---------- */
  function esc(s){return (s==null?'':String(s)).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  var FINALS={'ך':'כ','ם':'מ','ן':'נ','ף':'פ','ץ':'צ'};
  function norm(s){
    if(!s)return'';
    s=String(s).replace(/[\u0591-\u05C7]/g,'').replace(/[\u05F3\u05F4"'`׳״]/g,'').replace(/־/g,'-');
    s=s.replace(/\s*-\s*/g,' ').replace(/\s+/g,' ').trim();
    s=s.split('').map(function(c){return FINALS[c]||c;}).join('');
    if(s.indexOf('תל אביב')===0)s='תל אביב';
    return s;
  }
  var ALIAS={'תא':'תל אביב','ת א':'תל אביב','פת':'פתח תקווה','פ ת':'פתח תקווה','כס':'כפר סבא','כ ס':'כפר סבא','ראשלצ':'ראשון לציון','ראשל צ':'ראשון לציון'};
  function money(c){return '₪' + (c/100).toLocaleString('he-IL',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function ilNow(){
    var p=new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Jerusalem',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false,weekday:'short'}).formatToParts(new Date());
    var o={};p.forEach(function(x){o[x.type]=x.value;});
    var wd={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[o.weekday];
    return {y:+o.year,m:+o.month,d:+o.day,hh:+o.hour,mm:+o.minute,ss:+o.second,wd:wd};
  }
  function dateAdd(y,m,d,add){var dt=new Date(Date.UTC(y,m-1,d+add));return{y:dt.getUTCFullYear(),m:dt.getUTCMonth()+1,d:dt.getUTCDate(),wd:dt.getUTCDay()};}
  function iso(o){return o.y+'-'+('0'+o.m).slice(-2)+'-'+('0'+o.d).slice(-2);}
  function heDate(o){return ('0'+o.d).slice(-2)+'.'+('0'+o.m).slice(-2)+'.'+o.y;}
  function birdDate(o){return MON_EN[o.m-1]+' '+('0'+o.d).slice(-2)+', '+o.y;}

  /* Compute selectable dates for a zone weekday: next 3 occurrences that pass cutoff+blackout+full */
  function zoneDates(zone){
    var now=ilNow(), out=[], cut=CFG.cutoff.split(':'), cutMin=(+cut[0])*60+(+cut[1]);
    for(var add=0;add<28&&out.length<3;add++){
      var c=dateAdd(now.y,now.m,now.d,add);
      if(c.wd!==zone.weekday)continue;
      if(add===0&&(now.hh*60+now.mm)>=cutMin)continue;           /* past cutoff for today */
      var id=iso(c);
      if(CFG.blackout.indexOf(id)>-1)continue;
      out.push({date:c,iso:id,full:(zone.full_dates||[]).indexOf(id)>-1,limited:(zone.limited_dates||[]).indexOf(id)>-1});
    }
    return out;
  }

  /* ---------- data: cities + streets ---------- */
  var CITIES=null, CITY_IDX=null, CITY_BY_CODE={}, STREETS={}, SIDX={};
  function loadCities(){
    if(CITIES)return Promise.resolve(CITIES);
    return fetch(CFG.assets.cities).then(function(r){return r.json();}).then(function(list){
      CITIES=list; CITY_IDX={};
      list.forEach(function(c){
        CITY_IDX[norm(c.n)]=c;
        CITY_BY_CODE[c.c]=c;
        if(c.e)CITY_IDX[c.e.toLowerCase()]=c;
      });
      return list;
    });
  }
  function loadStreetIdx(ch){
    var code=ch.charCodeAt(0);
    if(SIDX[code])return Promise.resolve(SIDX[code]);
    var url=(CFG.assets.streetIdxBase||'').replace('CODE',code);
    return fetch(url).then(function(r){return r.ok?r.json():{};}).catch(function(){return{};}).then(function(d){SIDX[code]=d;return d;});
  }
  function cityZone(c){
    if(!c)return null;
    var n=norm(c.n), m=norm(c.m||'');
    for(var i=0;i<CFG.zones.length;i++){
      var z=CFG.zones[i];
      if(z._cityIdx.indexOf('|'+n+'|')>-1)return z;
      if(m&&z._councilIdx.indexOf('|'+m+'|')>-1)return z;
    }
    return null;
  }
  function cityZones(c){
    var out=[];if(!c)return out;
    var n=norm(c.n), m=norm(c.m||'');
    CFG.zones.forEach(function(z){
      if(z._cityIdx.indexOf('|'+n+'|')>-1||(m&&z._councilIdx.indexOf('|'+m+'|')>-1))out.push(z);
    });
    return out;
  }
  CFG.zones.forEach(function(z){
    z._cityIdx='|'+(z.cities||[]).map(norm).join('|')+'|';
    z._councilIdx='|'+(z.councils||[]).map(norm).join('|')+'|';
  });
  function loadStreets(code){
    if(STREETS[code])return Promise.resolve(STREETS[code]);
    var url=(CFG.assets.streetBase||'').replace('CODE',code);
    return fetch(url).then(function(r){return r.ok?r.json():[];}).catch(function(){return[];}).then(function(l){STREETS[code]=l;return l;});
  }

  /* address suggestion — Google primary (when key set + loaded), gov registry fallback */
  function suggest(raw){
    if(CFG.googleKey){
      loadGoogle(); /* warm up; falls through to local until ready */
      if(G.ready&&raw.trim().length>=3){
        return gSuggest(raw.trim()).then(function(preds){
          if(preds.length)return preds.map(function(p){
            var sf=p.structured_formatting||{};
            return {type:'g',pid:p.place_id,main:sf.main_text||p.description,sec:(sf.secondary_text||'').replace(/, ישראל$/,'')};
          });
          return localSuggest(raw); /* google found nothing — registry safety net */
        });
      }
    }
    return localSuggest(raw);
  }
  function localSuggest(raw){
    var q=norm(raw); if(q.length<2)return Promise.resolve([]);
    var alias=ALIAS[q]; if(alias)q=norm(alias);
    q=q.replace(/\d+/g,'').replace(/\s+/g,' ').trim(); /* house number handled at pick() */
    if(q.length<2)return Promise.resolve([]);
    return loadCities().then(function(list){
      /* optional trailing city ("אחוזה רעננה") */
      var parts=q.split(' '), tailCity=null, streetQ=q, i;
      var tries=[[parts.slice(-1).join(' '),parts.slice(0,-1).join(' ')],[parts.slice(-2).join(' '),parts.slice(0,-2).join(' ')]];
      for(i=0;i<tries.length;i++){
        var t=CITY_IDX[tries[i][0]];
        if(t&&tries[i][1].length>=2){tailCity=t;streetQ=tries[i][1];break;}
      }
      /* city prefix hits */
      var cityHits=[];
      for(i=0;i<list.length;i++){
        var c=list[i], n=norm(c.n);
        if(n.indexOf(q)===0||(c.e&&c.e.toLowerCase().indexOf(q)===0)){
          cityHits.push({type:'city',city:c,score:(n===q?0:1)+(cityZones(c).length?0:.5)});
          if(cityHits.length>30)break;
        }
      }
      /* street hits via reverse index bucket */
      return loadStreetIdx(streetQ[0]).then(function(bucket){
        var streetHits=[],k;
        for(k in bucket){
          if(k.indexOf(streetQ)!==0)continue;
          var entry=bucket[k], display=entry[0], codes=entry[1];
          for(i=0;i<codes.length;i++){
            var city=CITY_BY_CODE[codes[i]];
            if(!city)continue;
            if(tailCity&&city.c!==tailCity.c)continue;
            streetHits.push({type:'street',city:city,street:display,score:(k===streetQ?0:.3)});
            if(streetHits.length>=8)break;
          }
          if(streetHits.length>=8)break;
        }
        streetHits.sort(function(a,b){return a.score-b.score;});
        cityHits.sort(function(a,b){return a.score-b.score;});
        var out=streetHits.slice(0,4).concat(cityHits.slice(0,6));
        return out.slice(0,6);
      });
    });
  }

  /* ---------- zip lookup v2 — precision-gated (exact building match only) ----------
     Fills the postcode ONLY when the geocoder returns the exact house number the
     customer typed. Road-level answers are ambiguous (one street = several zips),
     so anything less precise stays empty. Empty beats wrong. */
  function zipFromResults(results){
    for(var i=0;i<(results||[]).length;i++){
      var c=(results[i].address_components||[]).filter(function(x){return x.types.indexOf('postal_code')>-1;})[0];
      if(c&&/^\d{5,7}$/.test(c.long_name))return c.long_name;
    }
    return null;
  }
  function lookupZip(state){
    /* Zip source of truth = Google (licensed postal data). Three attempts:
       1) place details (done at pick)  2) forward geocode by address
       3) reverse geocode by coordinates — best IL coverage. Empty beats wrong. */
    if(!CFG.googleKey||!state.city||!state.addr1)return Promise.resolve(null);
    return loadGoogle().then(function(ok){
      if(!ok)return null;
      return new Promise(function(res){
        G.geo.geocode({address:state.addr1+', '+state.city.n,region:'il'},function(results,status){
          var zip=(status==='OK')?zipFromResults(results):null;
          if(zip||!state.loc)return res(zip);
          /* reverse pass — accept only when the premise matches OUR house number
             (otherwise the nearest neighbor's zip could sneak in) */
          var num=(state.addr1.match(/\d+/)||[])[0];
          G.geo.geocode({location:state.loc},function(r2,s2){
            if(s2!=='OK')return res(null);
            for(var i=0;i<(r2||[]).length;i++){
              var comps=r2[i].address_components||[];
              var pc=comps.filter(function(x){return x.types.indexOf('postal_code')>-1;})[0];
              var sn=comps.filter(function(x){return x.types.indexOf('street_number')>-1;})[0];
              if(pc&&/^\d{5,7}$/.test(pc.long_name)&&sn&&num&&sn.long_name===num)return res(pc.long_name);
            }
            res(null);
          });
        });
      });
    }).catch(function(){return null;});
  }

  /* ---------- Google provider (primary when key present; gov data = fallback) ---------- */
  var G={ready:false,loading:false,p:null};
  function loadGoogle(){
    if(!CFG.googleKey)return Promise.resolve(false);
    if(G.ready)return Promise.resolve(true);
    if(G.loading)return G.p;
    G.loading=true;
    G.p=new Promise(function(res){
      /* another script on the page may have loaded Maps already */
      if(window.google&&google.maps&&google.maps.places){
        try{
          G.svc=new google.maps.places.AutocompleteService();
          G.det=new google.maps.places.PlacesService(document.createElement('div'));
          G.geo=new google.maps.Geocoder();
          G.ses=new google.maps.places.AutocompleteSessionToken();
          G.ready=true;return res(true);
        }catch(e){}
      }
      window.__ckGmapsCb=function(){
        try{
          G.svc=new google.maps.places.AutocompleteService();
          G.det=new google.maps.places.PlacesService(document.createElement('div'));
          G.geo=new google.maps.Geocoder();
          G.ses=new google.maps.places.AutocompleteSessionToken();
          G.ready=true;res(true);
        }catch(e){res(false);}
      };
      /* the theme's store-map loads Maps too and guards with window.loadingGoogleMapsScript
         — share the same flag so exactly one loader ever runs */
      /* __ckOwnsGmaps is set inline by our section before the theme's map script
         runs. When it's on, the flag is OURS and must not make us stand down —
         only a real foreign <script> already in the DOM does. */
      var foreign=document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if(foreign||(window.loadingGoogleMapsScript&&!window.__ckOwnsGmaps)){
        var poll=setInterval(function(){
          if(window.google&&google.maps&&google.maps.places){
            clearInterval(poll);
            try{
              G.svc=new google.maps.places.AutocompleteService();
              G.det=new google.maps.places.PlacesService(document.createElement('div'));
              G.geo=new google.maps.Geocoder();
              G.ses=new google.maps.places.AutocompleteSessionToken();
              G.ready=true;res(true);
            }catch(e){res(false);}
          }
        },120);
        setTimeout(function(){clearInterval(poll);if(!G.ready)res(false);},8000);
        return;
      }
      window.loadingGoogleMapsScript=true; /* claim it so the theme won't inject a second copy */
      var s=document.createElement('script');
      s.src='https://maps.googleapis.com/maps/api/js?key='+encodeURIComponent(CFG.googleKey)+'&libraries=places,geometry&language=iw&region=IL&callback=__ckGmapsCb';
      s.async=true;s.onerror=function(){res(false);};
      document.head.appendChild(s);
    });
    return G.p;
  }
  function gSuggest(q){
    return new Promise(function(res){
      if(!G.ready)return res([]);
      G.svc.getPlacePredictions({input:q,sessionToken:G.ses,componentRestrictions:{country:'il'},language:'iw'},function(preds,status){
        res(status==='OK'&&preds?preds.slice(0,5):[]);
      });
    });
  }
  function gDetails(pid){
    return new Promise(function(res){
      if(!G.ready)return res(null);
      G.det.getDetails({placeId:pid,sessionToken:G.ses,fields:['address_components','geometry']},function(p,status){
        G.ses=new google.maps.places.AutocompleteSessionToken();
        res(status==='OK'?p:null);
      });
    });
  }
  function gComp(p,type){
    var c=(p.address_components||[]).filter(function(x){return x.types.indexOf(type)>-1;})[0];
    return c?bidi(c.long_name):'';
  }
  /* Google wraps Hebrew street names in invisible bidi controls (U+202C and
     friends). They render as nothing but travel into the order attributes and
     into any delivery-company API we hand the address to, where they corrupt
     lookups. Strip them at the source. */
  function bidi(s){return (s==null?'':String(s)).replace(/[‎‏‪-‮⁦-⁩]/g,'').replace(/\s{2,}/g,' ').trim();}

  /* ---------- cart I/O ---------- */
  function getCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}
  function setAttrs(attrs){
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:attrs})}).then(function(r){return r.json();});
  }
  /* Re-render theme cart HTML (page + drawer copies) without opening any drawer */
  function ckRefresh(){
    return fetch(location.pathname.indexOf('/cart')===0?'/cart?section_id=helper-cart':'/?section_id=helper-cart',{headers:{'Accept':'text/html'}})
      .then(function(r){return r.text();})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        ['AjaxCartForm','AjaxCartSubtotal'].forEach(function(id){
          var fresh=doc.getElementById(id);
          if(!fresh)return;
          document.querySelectorAll('#'+id).forEach(function(cur){
            cur.innerHTML=fresh.innerHTML;
            /* re-arm the theme's own remove/qty bindings (component-cart.js does the same after its swaps) */
            if(typeof cur.ajaxifyCartItems==='function')cur.ajaxifyCartItems();
          });
        });
        var cnt=doc.querySelector('[data-cart-count]'),tot=doc.querySelector('[data-cart-total]');
        if(cnt)document.querySelectorAll('[data-header-cart-count]').forEach(function(e){e.textContent=cnt.textContent;});
        if(tot)document.querySelectorAll('[data-header-cart-total]').forEach(function(e){e.innerHTML=tot.innerHTML;});
        document.dispatchEvent(new CustomEvent('cart-updated'));
      }).catch(function(){});
  }
  function addItem(id,qty,btnEl,flyTarget){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){if(!r.ok)throw r;return r.json();})
      .then(function(res){
        if(btnEl&&flyTarget)fly(btnEl,flyTarget);
        return ckRefresh().then(function(){
          document.dispatchEvent(new CustomEvent('ck:cart-changed'));
          return res;
        });
      });
  }

  /* ---------- effects ---------- */
  function fly(fromEl,toSel){
    var to=document.querySelector(toSel);if(!to||!fromEl)return;
    var a=fromEl.getBoundingClientRect(),b=to.getBoundingClientRect();
    var f=document.createElement('div');f.className='ck-fly';f.innerHTML=I.check;
    f.style.left=(a.left+a.width/2-13)+'px';f.style.top=(a.top+a.height/2-13)+'px';
    document.body.appendChild(f);
    var dx=(b.left+b.width/2)-(a.left+a.width/2),dy=(b.top+20)-(a.top+a.height/2);
    if(f.animate){
      f.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:'translate('+dx*.5+'px,'+(dy*.5-40)+'px) scale(1.15)',offset:.6,opacity:1},{transform:'translate('+dx+'px,'+dy+'px) scale(.3)',opacity:0}],{duration:650,easing:'cubic-bezier(.5,-0.2,.4,1)'}).onfinish=function(){f.remove();};
    }else f.remove();
  }
  /* elegant one-time crossing effect: gold-green shimmer sweep + soft glow on the bar */
  function celebrate(fsEl){
    if(!fsEl)return;
    try{if(sessionStorage.getItem('ck_fs_done'))return;sessionStorage.setItem('ck_fs_done','1');}catch(e){}
    if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    fsEl.classList.add('is-crossed');
    setTimeout(function(){fsEl.classList.remove('is-crossed');},2400);
  }

  /* ---------- checkout handoff (Storefront Cart API preferences) ---------- */
  function handoff(state){
    if(!CFG.sfToken)return Promise.resolve(false);
    return getCart().then(function(cart){
      var token=cart.token||''; /* keep ?key= — part of the cart identity */
      if(!token)return false;
      var gid='gid://shopify/Cart/'+token;
      var buyer={preferences:{delivery:{deliveryMethod:[state.method==='pickup'?'PICK_UP':'SHIPPING']}}};
      if(state.method==='delivery'&&state.city){
        var pref={city:state.city.n,country:'IL',address1:state.addr1||''};
        if(state.zip)pref.zip=state.zip;
        buyer.deliveryAddressPreferences=[{deliveryAddress:pref}];
      }
      var q='mutation($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!){cartBuyerIdentityUpdate(cartId:$cartId, buyerIdentity:$buyerIdentity){cart{id} userErrors{field message}}}';
      return fetch('/api/2025-01/graphql.json',{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':CFG.sfToken},body:JSON.stringify({query:q,variables:{cartId:gid,buyerIdentity:buyer}})})
        .then(function(r){return r.json();})
        .then(function(res){var ok=!!(res&&res.data&&res.data.cartBuyerIdentityUpdate&&res.data.cartBuyerIdentityUpdate.cart);if(!ok)console.warn('[ck] handoff skipped',res&&(res.errors||res.data&&res.data.cartBuyerIdentityUpdate.userErrors));return ok;})
        .catch(function(e){console.warn('[ck] handoff error',e);return false;});
    });
  }

  /* ---------- attributes ---------- */
  function writeAttrs(state){
    var a={};
    if(state.method==='pickup'){
      a['Delivery Method']='Pick Up';
      a['Delivery Location']=CFG.pickupAddress;
      a['משלוח - שיטה']='איסוף עצמי';
      a['משלוח - כתובת']=CFG.pickupAddress;
      a['locationId']='115108';a['shopifyLocationId']='87129981166';
      a['Delivery Date']='';a['Delivery Day']='';a['משלוח - יום']='';a['משלוח - תאריך']='';a['משלוח - חלון שעות']='';a['משלוח - אזור']='';a['משלוח - מיקוד']='';
    } else {
      a['Delivery Method']='Delivery';
      a['משלוח - שיטה']='משלוח עד הבית';
      /* clear pickup-only keys so a method switch never leaves stale data */
      a['Delivery Location']=(state.addr1?state.addr1+', ':'')+((state.city&&state.city.n)||'');
      a['locationId']='';a['shopifyLocationId']='';
      if(state.city){a['משלוח - אזור']=state.zone?state.zone.title:'';a['משלוח - כתובת']=(state.addr1?state.addr1+', ':'')+state.city.n;}
      if(state.sel){
        a['Delivery Date']=birdDate(state.sel.date);
        a['Delivery Day']=DAY_EN[state.sel.date.wd];
        a['משלוח - יום']=DAY_HE[state.sel.date.wd];
        a['משלוח - תאריך']=heDate(state.sel.date);
      }
      if(state.time)a['משלוח - חלון שעות']=state.time;
      /* always overwrite: a null zip must CLEAR the old one, or a corrected
         address would ship with the previous address's zip. Empty beats wrong. */
      a['משלוח - מיקוד']=state.zip||'';
    }
    return setAttrs(a);
  }

  /* ============================================================
     <ck-freeship>
     ============================================================ */
  function FreeShip(el){
    this.el=el;this.was=false;this.first=true;
    el.innerHTML='<div class="ck-fs"><div class="ck-fs__msg"></div><div class="ck-fs__track"><span class="ck-fs__fill" style="width:0%"></span><span class="ck-fs__truck" style="right:0%">'+I.truck+'</span></div></div>';
    this.box=el.querySelector('.ck-fs');
    this.msg=el.querySelector('.ck-fs__msg');this.fill=el.querySelector('.ck-fs__fill');this.truck=el.querySelector('.ck-fs__truck');
  }
  FreeShip.prototype.update=function(total){
    var pct=Math.min(100,total/CFG.free*100);
    this.fill.style.width=pct+'%';this.truck.style.right=pct+'%';
    if(total>=CFG.free){
      this.msg.className='ck-fs__msg is-done';
      this.msg.innerHTML=I.check+'<span>יש! ההזמנה זכאית ל<b style="margin:0 3px">משלוח חינם</b></span>';
      /* celebrate only on a genuine crossing inside this session — never on page load */
      if(!this.was&&!this.first)celebrate(this.box);
      this.was=true;
    } else {
      this.msg.className='ck-fs__msg';
      this.msg.innerHTML=I.truck+'<span>עוד <b style="margin:0 3px">'+money(CFG.free-total)+'</b> ומקבלים משלוח חינם</span>';
      if(this.was){try{sessionStorage.removeItem('ck_fs_done');}catch(e){}}
      this.was=false;
    }
    this.first=false;
  };

  /* ============================================================
     <ck-upsell> — curated handles + recommendations fallback
     ============================================================ */
  function Upsell(root,opts){
    this.root=root;this.opts=opts||{};this.items=[];this.cartIds={};
    var head='';
    if(this.opts.inline)head='<div class="ck-lbl" style="margin:0 2px 8px">'+I.spark+' משלימים את הארוחה?</div>';
    else if(!this.opts.compact)head='<div class="ck-up__head"><span class="ck-up__title">'+I.spark+' משלימים את הארוחה?</span><span class="ck-up__sub">מומלץ לפי העגלה</span></div>';
    root.innerHTML='<div class="ck-up">'+head+'<div class="ck-nudge-slot"></div><div class="ck-car"></div></div>';
    this.car=root.querySelector('.ck-car');this.nudgeSlot=root.querySelector('.ck-nudge-slot');
  }
  Upsell.prototype.skeleton=function(){
    if(this.items.length)return;
    this.car.innerHTML=Array(5).join('<div class="ck-ucard ck-skel"><div class="ck-ucard__img"></div><div class="ck-skel__l"></div><div class="ck-skel__l ck-skel__l--s"></div></div>');
  };
  Upsell.prototype.load=function(cart){
    var self=this;this.cart=cart;this.cartIds={};
    this.skeleton();
    (cart.items||[]).forEach(function(it){self.cartIds[it.product_id]=true;});
    var curated=CFG.upsellHandles||[];
    var seq=curated.length?Promise.all(curated.map(function(h){
      return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })):Promise.resolve([]);
    return seq.then(function(list){
      list=(list||[]).filter(Boolean);
      if(list.length)return list;
      var pid=cart.items&&cart.items[0]&&cart.items[0].product_id;
      if(!pid)return [];
      return fetch('/recommendations/products.json?product_id='+pid+'&limit=8',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():{products:[]};}).then(function(d){return d.products||[];}).catch(function(){return [];});
    }).then(function(prods){
      self.items=prods.filter(function(p){return p&&p.variants&&p.variants.length&&p.variants[0].available!==false;});
      self.render();
    });
  };
  Upsell.prototype.render=function(){
    var self=this,total=this.cart?this.cart.total_price:0;
    /* nudge */
    var gap=CFG.free-total;
    var candidates=this.items.filter(function(p){return !self.cartIds[p.id];});
    /* honest nudge: only when a single product genuinely crosses the free-shipping gap */
    var best=null,i;
    if(gap>0&&!this.opts.compact){
      for(i=0;i<candidates.length;i++){var pr=candidates[i].variants[0].price;if(pr>=gap&&(!best||pr<best.variants[0].price))best=candidates[i];}
    }
    if(best){
      this.nudgeSlot.innerHTML='<div class="ck-nudge"><span class="ck-nudge__ic">'+I.truck+'</span><span class="ck-nudge__t">עוד '+money(gap)+' למשלוח חינם. הוסיפו '+esc(best.title)+' ('+money(best.variants[0].price)+') ועברתם את הסף.</span><button type="button" data-vid="'+best.variants[0].id+'">הוספה</button></div>';
      var nb=this.nudgeSlot.querySelector('button');
      nb.addEventListener('click',function(){nb.disabled=true;addItem(+nb.dataset.vid,1,nb,self.opts.flyTo).catch(function(){}).then(function(){nb.disabled=false;});});
    } else this.nudgeSlot.innerHTML='';
    /* cards */
    this.car.innerHTML=this.items.slice(0,10).map(function(p){
      var v=p.variants[0],img=(p.images&&p.images[0])||p.featured_image||'';
      var imgUrl=typeof img==='string'?img:(img&&img.src)||'';
      if(imgUrl&&imgUrl.indexOf('//')===0)imgUrl='https:'+imgUrl;
      var inCart=!!self.cartIds[p.id];
      return '<div class="ck-ucard'+(inCart?' in-cart':'')+'"><div class="ck-ucard__img"'+(imgUrl?' style="background-image:url(\''+imgUrl.replace(/'/g,'')+'\')"':'')+'></div><div class="ck-ucard__n">'+esc(p.title)+'</div><div class="ck-ucard__row"><span class="ck-ucard__p">'+money(v.price)+'</span><button type="button" class="ck-ubtn'+(inCart?' is-added':'')+'" data-vid="'+v.id+'" aria-label="הוספה לעגלה">'+(inCart?I.check:I.plus)+'</button></div></div>';
    }).join('');
    this.car.querySelectorAll('.ck-ubtn').forEach(function(b){
      b.addEventListener('click',function(){
        b.disabled=true;
        addItem(+b.dataset.vid,1,b,self.opts.flyTo).catch(function(){}).then(function(){b.disabled=false;});
      });
    });
  };

  /* ============================================================
     <ck-delivery> — the main cart-page module
     ============================================================ */
  function Delivery(root){
    var self=this;
    /* prefer the aside mount inside the theme's cart column — one visual unit with the subtotal */
    var aside=document.querySelector('[data-ck-aside-mount]');
    if(aside)root=aside;
    this.root=root;
    root.removeAttribute('hidden');
    /* aid = address generation. Bumped on every pick so a slow zip lookup
       for a previous address can never write onto the current one. */
    this.state={method:'delivery',q:'',city:null,addr1:'',zone:null,zonesForCity:[],sel:null,time:null,done:false,aid:0};
    root.classList.add('ck-scope');
    root.innerHTML=
      '<div class="ck-delivery-wrap">'+
        '<ck-freeship-slot></ck-freeship-slot>'+
        '<div data-ck-upsell-inline></div>'+
        '<div class="ck-card">'+
          '<div class="ck-card__head"><span class="ck-card__badge">'+I.truck+'</span> פרטי המשלוח <span class="ck-dots"><i class="ck-dot is-on"></i><i class="ck-dot"></i><i class="ck-dot"></i></span></div>'+
          '<div data-ck-body></div>'+
        '</div>'+
        '<div data-ck-upsell></div>'+
      '</div>';
    this.fs=new FreeShip(root.querySelector('ck-freeship-slot'));
    this.body=root.querySelector('[data-ck-body]');
    this.dots=root.querySelectorAll('.ck-dot');
    /* upsell lives inside the funnel, right under the free-shipping bar */
    var upMount=root.querySelector('[data-ck-upsell-inline]')||root.querySelector('[data-ck-upsell]');
    this.upsell=new Upsell(upMount,{inline:true,flyTo:'#AjaxCartForm'});
    this.renderMethod();
    this.refreshCart();
    this.restore();
    document.addEventListener('ck:cart-changed',function(){self.refreshCart();});
    document.addEventListener('cart-updated',function(){self.refreshCart();});
    /* the theme dispatches 'cart-updated' on the <cart-form> element itself (non-bubbling) */
    var cf2=document.getElementById('AjaxCartForm');
    if(cf2)cf2.addEventListener('cart-updated',function(){self.refreshCart();});
    this.hookCheckout();
    loadCities();
  }
  Delivery.prototype.setDots=function(n){this.dots.forEach(function(d,i){d.classList.toggle('is-on',i<n);});};
  /* restore the shopper's earlier choice after a reload / return visit,
     reading it back from the cart attributes we already wrote */
  Delivery.prototype.restore=function(){
    var self=this,s=this.state;
    getCart().then(function(cart){
      var a=cart.attributes||{};
      if(a['Delivery Method']==='Pick Up'){
        s.method='pickup';self.renderMethod();self.gate();return;
      }
      var addr=a['משלוח - כתובת'],day=a['משלוח - יום'],win=a['משלוח - חלון שעות'];
      if(!addr)return;
      return loadCities().then(function(){
        var parts=addr.split(',');
        var cityName=(parts.pop()||'').trim();
        var rec=CITY_IDX[norm(cityName)];
        if(!rec)return;
        s.addr1=parts.join(',').trim();
        s.zip=a['משלוח - מיקוד']||null;
        s.q=addr;
        /* the address input lives in this.step (rendered by renderAddress), not in this.res */
        var inp=self.step&&self.step.querySelector('[data-ck-addr]');
        if(inp)inp.value=addr;
        self.applyPick({city:rec,addr1:s.addr1},inp,self.step&&self.step.querySelector('[data-ck-drop]'));
        /* re-select the same day and window if they are still offered */
        if(!day||!win)return;
        setTimeout(function(){
          var chips=self.res.querySelectorAll('[data-days] .ck-chip:not([disabled])');
          for(var i=0;i<chips.length;i++){
            if(chips[i].textContent.indexOf('יום '+day)>-1){
              chips[i].click();
              setTimeout(function(){
                var t=self.res.querySelectorAll('[data-times] .ck-chip');
                for(var j=0;j<t.length;j++){if(t[j].textContent.indexOf(win)>-1){t[j].click();break;}}
              },260);
              break;
            }
          }
        },260);
      });
    }).catch(function(){});
  };
  Delivery.prototype.refreshCart=function(){
    var self=this;
    return getCart().then(function(cart){
      self.cart=cart;
      self.fs.update(cart.total_price);
      self.upsell.load(cart);
      self.gate();
    });
  };
  Delivery.prototype.gate=function(){
    var btn=document.querySelector('button[name="checkout"][form="cart"]')||document.getElementById('CheckOut');
    if(!btn)return;
    var s=this.state,total=this.cart?this.cart.total_price:0;
    var ok,reason='';
    if(s.method==='pickup'){ok=true;}
    else if(total<CFG.min){ok=false;reason='מינימום להזמנה במשלוח '+money(CFG.min);}
    else if(!s.city){ok=false;reason='הזינו כתובת למשלוח כדי להמשיך';}
    else if(!s.zone){ok=false;reason='לכתובת הזו אין משלוח. דברו איתנו בוואטסאפ';} /* out of area: WhatsApp is the only path */
    else if(!s.sel){ok=false;reason='בחרו יום משלוח כדי להמשיך';}
    else if(!s.time){ok=false;reason='בחרו חלון שעות כדי להמשיך';}
    else ok=true;
    btn.disabled=!ok;
    var note=document.getElementById('ck-gate');
    if(!note){note=document.createElement('div');note.id='ck-gate';btn.parentNode&&btn.parentNode.insertBefore(note,btn.nextSibling);}
    note.className='ck-scope ck-gate'+(ok?' is-ok':'');
    note.innerHTML=ok?(s.method==='pickup'?I.check+' איסוף עצמי · '+esc(CFG.pickupAddress):(s.done?I.check+' המשלוח מתוזמן, אפשר להמשיך לתשלום':'' )):I.alert+' '+esc(reason);
    if(ok&&!s.done&&s.method!=='pickup')note.innerHTML='';
  };
  Delivery.prototype.hookCheckout=function(){
    var self=this;
    /* delegated on document — survives #AjaxCartForm re-renders */
    if(document.__ckCheckoutHooked)return;document.__ckCheckoutHooked=true;
    document.addEventListener('submit',function(ev){
      var form=ev.target;
      if(!form||form.id!=='cart')return;
      var sub=ev.submitter;
      if(!(sub&&sub.name==='checkout'))return;
      ev.preventDefault();
      sub.disabled=true;
      /* zip may still be resolving in the background — give it a short grace
         so the checkout leaves with the postcode whenever one exists */
      var zipWait=(self.state.method==='delivery'&&self.state.addr1&&!self.state.zip&&CFG.googleKey)
        ?Promise.race([
          (function(aid){return lookupZip(self.state).then(function(z){if(z&&self.state.aid===aid)self.state.zip=z;});})(self.state.aid),
          new Promise(function(r){setTimeout(r,2500);})
        ])
        :Promise.resolve();
      zipWait.catch(function(){}).then(function(){
        return writeAttrs(self.state).catch(function(){});
      }).then(function(){return handoff(self.state);}).catch(function(){return false;}).then(function(apiOk){
        /* tokenless address prefill via official cart-permalink checkout params.
           skipped when: API handoff succeeded, discounts applied (permalink would drop them), or nothing to prefill */
        return getCart().then(function(cart){
          var canPermalink=!apiOk && self.state.method==='delivery' && self.state.city && cart.items.length && (!cart.total_discount || cart.total_discount===0);
          if(canPermalink){
            var items=cart.items.map(function(it){return it.variant_id+':'+it.quantity;}).join(',');
            var p=[];
            for(var k in cart.attributes){if(cart.attributes[k]!=null&&cart.attributes[k]!=='')p.push('attributes['+encodeURIComponent(k)+']='+encodeURIComponent(cart.attributes[k]));}
            if(cart.note)p.push('note='+encodeURIComponent(cart.note));
            p.push('checkout[shipping_address][city]='+encodeURIComponent(self.state.city.n));
            if(self.state.addr1)p.push('checkout[shipping_address][address1]='+encodeURIComponent(self.state.addr1));
            p.push('checkout[shipping_address][country]='+encodeURIComponent('Israel'));
            location.href='/cart/'+items+'?'+p.join('&');
            return;
          }
          var f=document.createElement('form');f.method='post';f.action='/cart';f.style.display='none';
          var i=document.createElement('input');i.type='hidden';i.name='checkout';i.value='';f.appendChild(i);
          document.body.appendChild(f);f.submit();
        });
      });
    },true);
  };
  /* ---------- steps ---------- */
  Delivery.prototype.renderMethod=function(){
    var self=this,s=this.state;
    this.body.innerHTML=
      '<div class="ck-seg" role="tablist">'+
        '<button type="button" class="ck-seg__btn" data-m="delivery" aria-pressed="'+(s.method==='delivery')+'">'+I.truck+' משלוח עד הבית</button>'+
        '<button type="button" class="ck-seg__btn" data-m="pickup" aria-pressed="'+(s.method==='pickup')+'">'+I.store+' איסוף מהחנות</button>'+
      '</div><div data-ck-step></div>';
    this.body.querySelectorAll('.ck-seg__btn').forEach(function(b){
      b.addEventListener('click',function(){
        if(s.method===b.dataset.m)return;
        s.method=b.dataset.m;s.city=null;s.zone=null;s.sel=null;s.time=null;s.done=false;s.q='';s.addr1='';
        writeAttrs(s).catch(function(){});
        self.renderMethod();self.gate();
      });
    });
    this.step=this.body.querySelector('[data-ck-step]');
    if(s.method==='pickup')this.renderPickup();else this.renderAddress();
  };
  Delivery.prototype.renderPickup=function(){
    this.setDots(3);
    this.step.innerHTML='<div class="ck-step"><div class="ck-eta"><div class="ck-eta__hd">'+I.store+' איסוף עצמי</div><div class="ck-eta__big">'+esc(CFG.pickupAddress)+'</div><div class="ck-eta__sm">'+esc(CFG.pickupNote||'מוכן לאיסוף בתיאום מראש · ללא עלות משלוח')+'</div><span class="ck-eta__bdg">'+I.check+' ללא מינימום הזמנה</span></div></div>';
    var s=this.state;writeAttrs(s).catch(function(){});
    this.gate();
  };
  Delivery.prototype.renderAddress=function(){
    var self=this,s=this.state;
    this.setDots(1);
    this.step.innerHTML=
      '<div class="ck-step"><div class="ck-field"><label>'+I.pin+' לאן מגיעים? כתובת או יישוב</label><div class="ck-field__box"><span class="ck-field__pin">'+I.pin+'</span><input data-ck-addr autocomplete="off" inputmode="text" placeholder="למשל: אחוזה 120, רעננה" value="'+esc(s.q)+'"></div></div>'+
      '<ul class="ck-drop" data-ck-drop hidden></ul>'+
      '<div class="ck-hint" data-ck-hint hidden>לא מוצאים? <button type="button" data-ck-cityonly>בחרו יישוב מהרשימה</button></div>'+
      '<div data-ck-res></div></div>';
    var inp=this.step.querySelector('[data-ck-addr]'),drop=this.step.querySelector('[data-ck-drop]'),hint=this.step.querySelector('[data-ck-hint]');
    this.res=this.step.querySelector('[data-ck-res]');
    if(s.city&&s.zone&&!s.done)this.renderDays();
    if(s.done)this.renderDone();
    var t=null;
    inp.addEventListener('input',function(){
      s.q=inp.value;s.city=null;s.zone=null;s.sel=null;s.time=null;s.done=false;self.res.innerHTML='';self.setDots(1);self.gate();
      clearTimeout(t);
      t=setTimeout(function(){
        suggest(inp.value).then(function(hits){
          if(!hits.length){drop.hidden=true;hint.hidden=inp.value.trim().length<3;return;}
          hint.hidden=true;
          var typedNum=(inp.value.match(/\d+/)||[])[0]||'';
          drop.innerHTML=hits.map(function(h,ix){
            if(h.type==='g')return '<li data-ix="'+ix+'"><span class="ck-lp">'+I.pin+'</span><span>'+esc(h.main)+'<small>'+esc(h.sec)+'</small></span></li>';
            if(h.type==='street')return '<li data-ix="'+ix+'"><span class="ck-lp">'+I.pin+'</span><span>'+esc(h.street)+(typedNum?' '+esc(typedNum):'')+'<small>'+esc(h.city.n)+'</small></span></li>';
            var zs=cityZones(h.city);
            return '<li data-ix="'+ix+'"><span class="ck-lp">'+I.pin+'</span><span>'+esc(h.city.n)+'<small>'+(zs.length?'באזור החלוקה שלנו':'מחוץ לאזור החלוקה')+'</small></span></li>';
          }).join('');
          drop.hidden=false;
          drop.querySelectorAll('li').forEach(function(li){
            li.addEventListener('click',function(){self.pick(hits[+li.dataset.ix],inp,drop);});
          });
        });
      },140);
    });
    inp.addEventListener('keydown',function(ev){if(ev.key==='Enter'){ev.preventDefault();var f=drop.querySelector('li');if(f)f.click();}});
    this.step.querySelector('[data-ck-cityonly]').addEventListener('click',function(){inp.value='';inp.focus();hint.hidden=true;});
  };
  Delivery.prototype.pick=function(hit,inp,drop){
    var self=this,s=this.state;
    if(hit.type==='g'){
      /* Google selection: resolve full details (street, number, city, zip) in one call */
      drop.hidden=true;inp.value=hit.main+(hit.sec?', '+hit.sec:'');
      gDetails(hit.pid).then(function(p){
        if(!p){self.applyPick({city:{n:'',m:''},addr1:''},inp,drop);return;}
        var route=gComp(p,'route'),num=gComp(p,'street_number'),city=gComp(p,'locality')||gComp(p,'postal_town')||gComp(p,'administrative_area_level_2');
        var typedNum=(s.q.match(/\d+/)||[])[0];
        var zip=gComp(p,'postal_code');
        var rec=CITY_IDX?CITY_IDX[norm(city)]:null;
        var cityRec=rec||{n:city,m:''};
        s.zip=(zip&&/^\d{5,7}$/.test(zip))?zip:null;
        s.loc=(p.geometry&&p.geometry.location)?{lat:p.geometry.location.lat(),lng:p.geometry.location.lng()}:null;
        self.applyPick({city:cityRec,addr1:route?(route+(num||typedNum?' '+(num||typedNum):'')):''},inp,drop);
        /* warm the zip early (details had none) so it's ready before checkout */
        if(!s.zip){var aid=s.aid;lookupZip(s).then(function(z){if(z&&s.city&&s.aid===aid){s.zip=z;writeAttrs(s).catch(function(){});}});}
      });
      return;
    }
    s.zip=null;s.loc=null;
    var addr1=hit.type==='street'?hit.street:'';
    var num=(s.q.match(/\d+/)||[])[0];
    if(hit.type==='street'&&num)addr1=hit.street+' '+num;
    this.applyPick({city:hit.city,addr1:addr1},inp,drop);
  };
  Delivery.prototype.applyPick=function(sel,inp,drop){
    var self=this,s=this.state;
    s.aid=(s.aid||0)+1;
    s.city=sel.city;s.addr1=sel.addr1||'';
    if(!inp)inp=this.step&&this.step.querySelector('[data-ck-addr]');
    if(!drop)drop=this.step&&this.step.querySelector('[data-ck-drop]');
    /* zip hunt starts at pick time, every path — and paints into the pill the moment it lands */
    if(s.method==='delivery'&&s.addr1&&!s.zip){
      /* silent: fills the order + checkout when Google has it, never shown in the UI */
      var aid=s.aid;
      lookupZip(s).then(function(z){
        if(!z||!s.addr1||s.aid!==aid)return;
        s.zip=z;writeAttrs(s).catch(function(){});
      });
    }
    if(inp)inp.value=(s.addr1?s.addr1+', ':'')+(s.city.n||'');
    s.q=inp?inp.value:s.q;
    if(drop)drop.hidden=true;
    var zones=cityZones(s.city);
    s.zonesForCity=zones;s.zone=zones[0]||null;s.sel=null;s.time=null;s.done=false;
    writeAttrs(s).catch(function(){});
    if(!s.city.n){this.gate();return;}
    if(!zones.length){this.renderOos();this.gate();return;}
    this.renderDays();this.gate();
  };
  Delivery.prototype.initGMap=function(tries){
    var self=this,s=this.state;
    var el=this.res.querySelector('[data-ck-gmap]');
    if(!el||!s.loc||!G.ready)return;
    /* container not laid out yet (hidden panel / zero width) — retry briefly */
    if(el.getBoundingClientRect().width<40){
      if((tries||0)<12)setTimeout(function(){self.initGMap((tries||0)+1);},250);
      return;
    }
    var map=new google.maps.Map(el,{
      center:s.loc,zoom:16,disableDefaultUI:true,gestureHandling:'none',
      clickableIcons:false,keyboardShortcuts:false,
      styles:[{featureType:'poi',stylers:[{visibility:'off'}]},{featureType:'transit',stylers:[{visibility:'off'}]}]
    });
    this._gmap=map;
    new google.maps.Marker({map:map,position:s.loc,icon:{
      path:'M12 2C7.6 2 4 5.6 4 10c0 5.4 8 12 8 12s8-6.6 8-12c0-4.4-3.6-8-8-8z',
      fillColor:'#3d6b45',fillOpacity:1,strokeColor:'#ffffff',strokeWeight:2,scale:1.6,anchor:new google.maps.Point(12,22)
    }});
  };
  Delivery.prototype.mapHtml=function(){
    var s=this.state;
    if(s.loc&&G.ready){
      return '<div class="ck-map"><div data-ck-gmap style="position:absolute;inset:0"></div>'+
        '<span class="ck-map__tag ck-map__tag--city">'+I.pin+' '+esc((s.addr1?s.addr1+', ':'')+s.city.n)+'</span></div>';
    }
    return '<div class="ck-map"><svg viewBox="0 0 340 150" preserveAspectRatio="xMidYMid slice">'+
      '<rect width="340" height="150" fill="#e7efe4"/>'+
      '<g opacity=".55"><rect x="18" y="12" width="52" height="32" rx="3" fill="#d9e5d5"/><rect x="90" y="9" width="70" height="28" rx="3" fill="#dce7d8"/><rect x="248" y="16" width="72" height="38" rx="3" fill="#d9e5d5"/><rect x="28" y="86" width="64" height="44" rx="3" fill="#dce7d8"/><rect x="198" y="92" width="92" height="44" rx="3" fill="#d9e5d5"/><rect x="120" y="96" width="56" height="38" rx="3" fill="#dfeadb"/></g>'+
      '<g stroke="#cdddc8" stroke-width="9" stroke-linecap="round"><path d="M-5 58h350"/><path d="M-5 84h350"/><path d="M76 -5v160"/><path d="M186 -5v160"/></g>'+
      '<g stroke="#f2f7f0" stroke-width="3"><path d="M-5 71h350"/><path d="M131 -5v160"/><path d="M253 -5v160"/></g>'+
      '<path id="ck-route-path" class="ck-route ck-draw" d="M50 122 C108 114 118 66 186 58 C238 52 248 42 286 38" fill="none" stroke="#3d6b45" stroke-width="2.6" stroke-linecap="round"/>'+
      (matchMedia('(prefers-reduced-motion: reduce)').matches?'':(
      '<g opacity="0"><animate attributeName="opacity" values="0;1" begin="1.3s" dur="0.3s" fill="freeze"/>'+
        '<g><animateMotion dur="7s" begin="1.3s" repeatCount="indefinite" rotate="auto" keyPoints="0;1;1" keyTimes="0;0.75;1" calcMode="linear"><mpath href="#ck-route-path"/></animateMotion>'+
        '<g><rect x="-7" y="-6" width="13" height="8" rx="2" fill="#24462c"/><rect x="4" y="-4" width="5" height="6" rx="1.4" fill="#24462c"/><circle cx="-3" cy="3.4" r="1.9" fill="#fff" stroke="#24462c" stroke-width="1.4"/><circle cx="5.5" cy="3.4" r="1.9" fill="#fff" stroke="#24462c" stroke-width="1.4"/></g></g></g>'))+
      '<g><rect x="44" y="114" width="12" height="12" rx="3" fill="#24462c"/><path d="M46 114l4-4 4 4" fill="none" stroke="#24462c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g>'+
      '<circle class="ck-pulse" cx="286" cy="38" r="4" fill="none" stroke="#3d6b45" stroke-width="2"/>'+
      '<g class="ck-pin"><path d="M286 22c-5 0-9 4-9 9 0 6.5 9 15 9 15s9-8.5 9-15c0-5-4-9-9-9z" fill="#24462c"/><circle cx="286" cy="31" r="3.4" fill="#eaf3ec"/></g>'+
      '</svg><span class="ck-map__tag ck-map__tag--store">'+I.store+' נקודת יציאה · כפר סבא</span><span class="ck-map__tag ck-map__tag--city">'+I.pin+' '+esc(s.city.n)+'</span></div>';
  };
  Delivery.prototype.renderDays=function(){
    var self=this,s=this.state;
    this.setDots(2);
    var opts=[];
    s.zonesForCity.forEach(function(z){zoneDates(z).forEach(function(d){opts.push({zone:z,o:d});});});
    opts.sort(function(a,b){return a.o.iso<b.o.iso?-1:1;});
    opts=opts.slice(0,4);
    var html='<div class="ck-step">'+this.mapHtml()+
      '<div class="ck-pill"><span class="ck-pill__ic">'+I.check+'</span><span>מגיעים אליך! '+esc(s.city.n)+' · '+esc((s.zonesForCity[0]||{}).title||'')+'</span></span></div>'+
      '<div class="ck-lbl">'+I.cal+' בחרו יום משלוח</div><div class="ck-chips" data-days></div></div>';
    this.res.innerHTML=html;
    this.initGMap();
    var wrap=this.res.querySelector('[data-days]');
    if(!opts.length){wrap.innerHTML='<div class="ck-oos"><div class="ck-oos__t">'+I.alert+' אין כרגע ימים פנויים</div><p>נסו שוב מחר, או דברו איתנו בוואטסאפ ונמצא פתרון.</p></div>';return;}
    wrap.innerHTML=opts.map(function(x,ix){
      var full=x.o.full,low=x.o.limited;
      return '<button type="button" class="ck-chip" data-ix="'+ix+'" '+(full?'disabled':'')+' aria-pressed="false"><span class="ck-chip__l">'+I.cal+'יום '+DAY_HE[x.o.date.wd]+' · '+('0'+x.o.date.d).slice(-2)+'.'+('0'+x.o.date.m).slice(-2)+'</span><span class="ck-chip__cap'+(low?' is-low':'')+'">'+(full?I.alert+'מלא':(low?I.flame+'כמעט מלא':I.check+'פנוי'))+'</span></button>';
    }).join('');
    wrap.querySelectorAll('.ck-chip:not([disabled])').forEach(function(b){
      b.addEventListener('click',function(){
        var x=opts[+b.dataset.ix];
        s.zone=x.zone;s.sel=x.o;s.time=null;s.done=false;
        writeAttrs(s).catch(function(){});
        if(s.addr1&&!s.zip){var aidD=s.aid;lookupZip(s).then(function(z){if(z&&s.aid===aidD){s.zip=z;writeAttrs(s).catch(function(){});}});}
        self.renderTimes();self.gate();
      });
    });
  };
  Delivery.prototype.renderTimes=function(){
    var self=this,s=this.state;
    this.setDots(2);
    this.res.innerHTML='<div class="ck-step"><button type="button" class="ck-back" data-back>'+I.back+' יום אחר</button>'+
      '<div class="ck-pill"><span class="ck-pill__ic">'+I.cal+'</span>יום '+DAY_HE[s.sel.date.wd]+' · '+heDate(s.sel.date)+' · '+esc(s.city.n)+'</div>'+
      '<div class="ck-lbl">'+I.clock+' באיזה חלון שעות נוח לקבל?</div><div class="ck-chips" data-times></div></div>';
    this.res.querySelector('[data-back]').addEventListener('click',function(){s.sel=null;s.time=null;self.renderDays();self.gate();});
    var wrap=this.res.querySelector('[data-times]');
    /* a day can narrow its own windows (Thursday has no evening slot);
       an empty list on the zone falls back to the global windows */
    var zw=s.zone&&s.zone.windows;
    var wins=(zw&&zw.length)?zw:CFG.windows;
    wrap.innerHTML=wins.map(function(t){
      return '<button type="button" class="ck-chip" data-t="'+esc(t)+'" aria-pressed="false"><span class="ck-chip__l">'+I.clock+esc(t)+'</span><span class="ck-chip__cap">'+I.check+'פנוי</span></button>';
    }).join('');
    wrap.querySelectorAll('.ck-chip').forEach(function(b){
      b.addEventListener('click',function(){
        s.time=b.dataset.t;s.done=true;
        writeAttrs(s).catch(function(){});
        self.renderDone();self.gate();
        /* precision-gated zip enrichment — fills only on exact building match */
        if(!s.zip){var aidS=s.aid;lookupZip(s).then(function(z){if(z&&s.done&&s.aid===aidS){s.zip=z;writeAttrs(s).catch(function(){});}});}
      });
    });
  };
  Delivery.prototype.renderDone=function(){
    var self=this,s=this.state;
    this.setDots(3);
    this.res.innerHTML='<div class="ck-step"><button type="button" class="ck-back" data-back>'+I.back+' שינוי</button>'+
      '<div class="ck-eta is-done">'+
      '<svg class="ck-eta__check" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="17.5" stroke="currentColor" stroke-width="2.4"/><path d="M12.5 20.5l5 5 10-11" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
      '<div class="ck-eta__hd">'+I.truck+' המשלוח שלך נקבע</div>'+
      '<div class="ck-eta__big">יום '+DAY_HE[s.sel.date.wd]+', '+heDate(s.sel.date)+'</div>'+
      '<div class="ck-eta__sm">בין '+esc(s.time)+' · אל '+esc((s.addr1?s.addr1+', ':'')+s.city.n)+'</div>'+
      '<div class="ck-eta__chips">'+
        '<span class="ck-cold"><span class="ck-cold__flakes"><i></i><i></i><i></i></span><svg class="ck-cold__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3v18M4.5 7.5l15 9M19.5 7.5l-15 9M12 6l-2.2-1.8M12 6l2.2-1.8M12 18l-2.2 1.8M12 18l2.2 1.8M6 9.2L3.3 8.6M6 14.8l-2.7.6M18 9.2l2.7-.6M18 14.8l2.7.6" stroke-linecap="round"/></svg> מגיע בקירור מלא</span>'+
      '</div></div></div>';
    this.res.querySelector('[data-back]').addEventListener('click',function(){s.time=null;s.done=false;self.renderTimes();self.gate();});
  };
  Delivery.prototype.renderOos=function(){
    var self=this,s=this.state;
    this.setDots(1);
    var items=(this.cart&&this.cart.items)||[];
    /* The whole cart goes in, with per-line prices: Lior quotes the special
       delivery off this message, so a truncated list sends him back to asking.
       The only guard is the encoded URL length — Hebrew costs 6 chars per
       letter once encoded, and a broken link helps nobody. ~7000 is roughly
       40 line items, which a real food order never reaches. */
    var lines=[],cut=0,budget=7000,used=0;
    items.forEach(function(it){
      var price=(typeof it.final_line_price==='number')?it.final_line_price:it.line_price;
      /* variant matters: two sizes of the same product would otherwise read as
         one product listed twice at different prices, which looks like an error */
      var name=it.product_title+((it.variant_title&&it.variant_title!=='Default Title')?' ('+it.variant_title+')':'');
      var l='• '+name+(it.quantity>1?' ×'+it.quantity:'')+' · '+money(price);
      var cost=encodeURIComponent(l+'\n').length;
      if(used+cost>budget){cut++;return;}
      used+=cost;lines.push(l);
    });
    if(cut)lines.push('ועוד '+cut+' פריטים');
    var full=(s.addr1?s.addr1+', ':'')+s.city.n+(s.zip?', '+s.zip:'');
    var msg='היי, אני מ'+s.city.n+' ורוצה לבדוק אפשרות למשלוח מיוחד.\n'+
      'הכתובת שלי: '+full+'\n\n'+
      'ההזמנה שלי:\n'+lines.join('\n')+'\nסה"כ '+money(this.cart?this.cart.total_price:0)+'.';
    this.res.innerHTML='<div class="ck-step"><div class="ck-oos"><div class="ck-oos__t">'+I.alert+' ל'+esc(s.city.n)+' עדיין לא מחלקים</div>'+
      '<p>שלחו לנו הודעה ונבדוק משלוח מיוחד. ההודעה כבר מוכנה:</p>'+
      '<div class="ck-wapre"><b>ההודעה שתישלח</b>'+esc(msg).replace(/\n/g,'<br>')+'</div>'+
      '<a class="ck-wa" target="_blank" rel="noopener" href="https://wa.me/'+esc(CFG.wa)+'?text='+encodeURIComponent(msg)+'">'+I.wa+' שליחת ההודעה בוואטסאפ</a></div></div>';
  };

  /* ============================================================
     <ck-popup-extra> — free-ship bar + compact upsell in popup
     ============================================================ */
  function PopupExtra(root){
    var self=this;
    root.classList.add('ck-scope');
    root.innerHTML='<div class="ck-popup-extra"><ck-freeship-slot></ck-freeship-slot><div class="ck-lbl" style="margin:0">'+I.spark+' העגלה שלך <span class="ck-mini__count" data-mini-count></span></div><div class="ck-mini" data-mini></div><div class="ck-lbl" style="margin:0">'+I.spark+' כדאי להוסיף גם</div><div data-up></div></div>';
    this.fs=new FreeShip(root.querySelector('ck-freeship-slot'));
    this.mini=root.querySelector('[data-mini]');
    this.miniCount=root.querySelector('[data-mini-count]');
    this.upsell=new Upsell(root.querySelector('[data-up]'),{compact:true,flyTo:'#site-cart-sidebar .sidebar__header'});
    root.addEventListener('click',function(ev){
      var b=ev.target.closest('[data-mini-act]');
      if(!b)return;
      ev.preventDefault();
      var line=+b.getAttribute('data-line'),act=b.getAttribute('data-mini-act');
      var qty=+b.getAttribute('data-qty');
      var next=act==='inc'?qty+1:(act==='dec'?qty-1:0);
      b.disabled=true;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:next})})
        .then(function(r){return r.json();})
        .then(function(){return ckRefresh();})
        .then(function(){document.dispatchEvent(new CustomEvent('ck:cart-changed'));});
    });
    var refresh=function(){getCart().then(function(cart){
      self.fs.update(cart.total_price);
      self.upsell.load(cart);
      self.miniCount.textContent=cart.item_count?'('+cart.item_count+')':'';
      self.mini.innerHTML=(cart.items||[]).map(function(it,ix){
        var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_100x$1$2'):'';
        return '<div class="ck-mini__row">'+
          '<span class="ck-mini__img"'+(img?' style="background-image:url(\''+img+'\')"':'')+'></span>'+
          '<span class="ck-mini__info"><span class="ck-mini__name">'+esc(it.product_title)+'</span>'+
          '<span class="ck-mini__qty"><button type="button" data-mini-act="inc" data-line="'+(ix+1)+'" data-qty="'+it.quantity+'" aria-label="הוספה">'+I.plus+'</button><b>'+it.quantity+'</b><button type="button" data-mini-act="dec" data-line="'+(ix+1)+'" data-qty="'+it.quantity+'" aria-label="הפחתה">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 12h14" stroke-linecap="round"/></svg></button>'+
          '<button type="button" class="ck-mini__rm" data-mini-act="rm" data-line="'+(ix+1)+'" data-qty="'+it.quantity+'" aria-label="הסרה"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button></span></span>'+
          '<span class="ck-mini__price">'+money(it.final_line_price)+'</span></div>';
      }).join('')||'<div class="ck-mini__empty">העגלה ריקה</div>';
    });};
    document.addEventListener('add-to-cart',function(){setTimeout(refresh,300);});
    document.addEventListener('ck:cart-changed',function(){setTimeout(refresh,200);});
    /* robust: the theme injects the added item into the popup body — observe it */
    var target=document.querySelector('[data-js-site-cart-popup-content]');
    if(target&&window.MutationObserver){
      new MutationObserver(function(){setTimeout(refresh,250);}).observe(target,{childList:true});
    }
    refresh();
  }

  /* ---------- drawer slots (overlay side-drawer variant) ---------- */
  function DrawerBits(barEl,upEl){
    var self=this;
    this.fs=barEl?new FreeShip(barEl):null;
    this.upsell=upEl?new Upsell(upEl,{compact:true,flyTo:'#site-cart-sidebar .sidebar__header'}):null;
    var refresh=function(){getCart().then(function(cart){
      if(self.fs)self.fs.update(cart.total_price);
      if(self.upsell)self.upsell.load(cart);
    });};
    document.addEventListener('ck:cart-changed',function(){setTimeout(refresh,200);});
    document.addEventListener('cart-updated',function(){setTimeout(refresh,200);});
    document.addEventListener('add-to-cart',function(){setTimeout(refresh,350);});
    var cf=document.getElementById('AjaxCartForm');
    if(cf)cf.addEventListener('cart-updated',function(){setTimeout(refresh,150);});
    refresh();
  }

  /* ---------- universal cart-change detector ----------
     the theme doesn't emit an event on ADD (only on qty/remove), so we
     watch the network: any /cart/add|change|update|clear resolves →
     everyone refreshes. covers every add path, present and future. */
  function hookCartFetch(){
    if(window.__ckFetchHook)return;window.__ckFetchHook=true;
    var of=window.fetch;
    window.fetch=function(u){
      var p=of.apply(this,arguments);
      try{
        var url=(typeof u==='string')?u:((u&&u.url)||'');
        if(/\/cart\/(add|change|update|clear)/.test(url)){
          p.then(function(){setTimeout(function(){document.dispatchEvent(new CustomEvent('ck:cart-changed'));},180);},function(){});
        }
      }catch(e){}
      return p;
    };
  }

  /* ---------- zip self-test (?ckzipdebug) — one-line on-screen verdict ---------- */
  function zipDebug(){
    if(location.search.indexOf('ckzipdebug')===-1)return;
    var say=function(msg,ok){
      var d=document.createElement('div');
      d.style.cssText='position:fixed;top:12px;left:12px;right:12px;z-index:99999;padding:14px 18px;border-radius:12px;font:700 15px/1.4 sans-serif;direction:rtl;color:#fff;background:'+(ok?'#2e7d47':'#b8452f');
      d.textContent=msg;document.body.appendChild(d);
    };
    loadGoogle().then(function(ok){
      if(!ok)return say('בדיקת מיקוד: גוגל לא נטען בכלל בדפדפן הזה',false);
      G.geo.geocode({address:'אחוזה 120, רעננה',region:'il'},function(r,status){
        var zip=(status==='OK')?zipFromResults(r):null;
        if(zip)say('בדיקת מיקוד: עובד! אחוזה 120 רעננה ← '+zip,true);
        else say('בדיקת מיקוד נכשלה · status='+status+' · תוצאות='+((r&&r.length)||0),false);
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(){
    hookCartFetch();
    zipDebug();
    /* claim the Maps loader early (with places+geometry) so the theme's
       lighter loader never wins the race and strips the places library */
    if(CFG.googleKey&&document.querySelector('ck-delivery'))loadGoogle();
    document.querySelectorAll('ck-delivery').forEach(function(el){if(!el.__ck)el.__ck=new Delivery(el);});
    document.querySelectorAll('ck-popup-extra').forEach(function(el){if(!el.__ck)el.__ck=new PopupExtra(el);});
    var dbar=document.querySelector('[data-ck-drawer-bar]'),dup=document.querySelector('[data-ck-drawer-upsell]');
    if((dbar||dup)&&!window.__ckDrawerBits)window.__ckDrawerBits=new DrawerBits(dbar,dup);
    /* header cart: in overlay mode the theme's own [data-js-sidebar-handle]
       already opens the drawer — we only refresh our bits when it opens. */
    var pop=document.getElementById('site-cart-sidebar');
    if(pop&&!document.__ckHeaderHooked){
      document.__ckHeaderHooked=true;
      document.querySelectorAll('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]').forEach(function(h){
        h.addEventListener('click',function(){setTimeout(function(){document.dispatchEvent(new CustomEvent('ck:cart-changed'));},120);});
      });
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

/* v-bump */
